import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<EisaScoring @config={{this.config}} @results={{this.results}} />\n",{ moduleName: "bullitt-time-live/templates/event/eisa-scoring.hbs" })